<template>
  <div class="comp-bench-radio">
    <el-radio-group
      v-model="defaultRadio"
      @change="radioChange"
    >
      <el-radio
        v-for="(radio, index) in radios"
        :key="index"
        :label="radio.value"
      >
        {{ radio.label }}
      </el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: 'BenchRadio',
  props: {
    value: {
      type: [String, Boolean, Number],
      default: 2
    },
    radios: {
      type: Array,
      default: () => [
        { value: 1, label: '选项1' },
        { value: 2, label: '选项2' }
      ]
    }
  },
  data() {
    return {
      defaultRadio: this.value
    };
  },
  watch: {
    value(nv) {
      this.defaultRadio = nv;
    }
  },
  async mounted() {},
  methods: {
    radioChange(value) {
      this.$emit('input', value);
      this.$emit('chagne', value);
    }
  }
};
</script>

<style lang="scss">
/* @import url(); 引入css类 */
.comp-bench-radio {
  color: #333;
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #666;
    background: #666;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #666;
  }
  .el-radio__inner:hover {
    border-color: #666;
  }
}
</style>
